import services from '@/http'
import * as types from './mutation-types'

export const ActionAddCarGarage = (context,payload) => (
  services.add_car.addCarGarage(payload).then(res => {
    return res.status
    
  })
)
export const ActionGetCarModel = (context,payload) => (
  services.add_car.getCarModel({model:payload}).then(res => {
    context.commit(types.GET_CAR_MODEL, res.data.results)
    return res.data.results
    
  })
)
export const ActionGetCarVersion = (context,payload) => (
  services.add_car.getCarVersion({model__name:payload.model__name, year__year:payload.year__year}).then(res => {
    if (res.data.results.length == 0) {
      return 0
    }
    else {
      context.commit(types.GET_CAR_VERSION, res.data.results)
      return res.data.results
    }

    
  })
)